var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpalLogoFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arr",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 8,
    markerHeight: 8,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 1L8 5L2 9",
    fill: "none",
    stroke: "#185FA5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-clip"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 512,
    height: 512,
    rx: 100
  })), /*#__PURE__*/React.createElement("mask", {
    id: "imagine-text-gaps-vzfcp7",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 522,
    height: 522,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.6484375,
    y: 293,
    width: 271.1025390625,
    height: 102,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.3359375,
    y: 396,
    width: 295.328125,
    height: 28.6298828125,
    fill: "black",
    rx: 2
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 512,
    height: 512,
    rx: 100,
    fill: "#F25C54",
    style: {
      fill: "rgb(242, 92, 84)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 512,
    height: 512,
    rx: 100,
    fill: "#FDE8E7",
    opacity: 0.06,
    style: {
      fill: "rgb(253, 232, 231)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.06,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148 108 C126 108 108 126 108 150 C108 180 148 218 148 218 C148 218 188 180 188 150 C188 126 170 108 148 108 Z",
    fill: "#FDE8E7",
    opacity: 0.65,
    style: {
      fill: "rgb(253, 232, 231)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.65,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 149,
    r: 18,
    fill: "#F25C54",
    opacity: 0.5,
    style: {
      fill: "rgb(242, 92, 84)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.5,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 149,
    r: 7,
    fill: "#FDE8E7",
    opacity: 0.6,
    style: {
      fill: "rgb(253, 232, 231)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.6,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 138 Q256 58 318 128",
    fill: "none",
    stroke: "#FDE8E7",
    strokeWidth: 5,
    strokeDasharray: "10 8",
    strokeLinecap: "round",
    markerEnd: "url(#arr)",
    style: {
      fill: "none",
      stroke: "rgb(253, 232, 231)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 5,
      strokeDasharray: "10px, 8px",
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364 88 C338 88 318 108 318 136 C318 170 364 218 364 218 C364 218 410 170 410 136 C410 108 390 88 364 88 Z",
    fill: "#185FA5",
    style: {
      fill: "rgb(24, 95, 165)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364,
    cy: 134,
    r: 22,
    fill: "#E6F1FB",
    style: {
      fill: "rgb(230, 241, 251)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364,
    cy: 134,
    r: 9,
    fill: "#185FA5",
    style: {
      fill: "rgb(24, 95, 165)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 248,
    r: 22,
    fill: "#FDE8E7",
    style: {
      fill: "rgb(253, 232, 231)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 290 Q230 272 256 268 Q282 272 282 290",
    fill: "#FDE8E7",
    style: {
      fill: "rgb(253, 232, 231)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 272,
    width: 26,
    height: 20,
    rx: 4,
    fill: "#B5D4F4",
    style: {
      fill: "rgb(181, 212, 244)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291,
    y: 266,
    width: 16,
    height: 8,
    rx: 2,
    fill: "none",
    stroke: "#B5D4F4",
    strokeWidth: 2.5,
    style: {
      fill: "none",
      stroke: "rgb(181, 212, 244)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 299,
    y1: 272,
    x2: 299,
    y2: 292,
    stroke: "#185FA5",
    strokeWidth: 1.5,
    opacity: 0.6,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(24, 95, 165)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.6,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 308,
    x2: 412,
    y2: 308,
    stroke: "#FDE8E7",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.3,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(253, 232, 231)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 0.3,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 374,
    textAnchor: "middle",
    style: {
      fontFamily: "Georgia, 'Times New Roman', serif",
      fontSize: 86,
      fontWeight: 700,
      letterSpacing: "-2px",
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Georgia, &quot",
      fontSize: 86,
      fontWeight: 700,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#FDE8E7",
    style: {
      fill: "rgb(253, 232, 231)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Georgia, &quot",
      fontSize: 86,
      fontWeight: 700,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "EX"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#185FA5",
    style: {
      fill: "rgb(24, 95, 165)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Georgia, &quot",
      fontSize: 86,
      fontWeight: 700,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Pal")), /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 418,
    textAnchor: "middle",
    style: {
      fontFamily: "Arial, Helvetica, sans-serif",
      fontSize: 22,
      fontWeight: 400,
      fill: "#FDE8E7",
      opacity: 0.85,
      letterSpacing: "0.5px",
      fill: "rgb(253, 232, 231)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.85,
      fontFamily: "Arial, Helvetica, sans-serif",
      fontSize: 22,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "\n    Your friend away from home\n  "));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpalLogoFull);
export default __webpack_public_path__ + "static/media/expal-logo-full.ae5daf1f3b0dc8d3849b439fd37fd3eb.svg";
export { ForwardRef as ReactComponent };